import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { SwrPaginationInterface } from 'shared/types/pagination-interface'
import { getPaginationQueryString } from 'shared/utils/api/get-pagination-query-string'
import useSWR from 'swr'
import { ContactId } from '../../types/contact-interface'
import { ContactCommunitiesApiInterface } from '../types/contact-communities-interface'

interface UseContactCommunitiesInterface extends SwrPaginationInterface {
  contactId: ContactId
}

export function useContactCommunities({
  limit,
  pagination,
  contactId,
}: UseContactCommunitiesInterface) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, ContactCommunitiesApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data: contactCommunities } = useSWR(() => {
    if (user) {
      return `/api/community/community-by-contact/${contactId}/list?${getPaginationQueryString({
        limit,
        pagination,
      })}`
    }
    return null
  }, fetcher)

  return { contactCommunities }
}
